import { DefaultFonts } from "survey-creator-core";

export default function AddCustomFonts() {
  if (!DefaultFonts.includes("Sora, sans-serif")) {
    DefaultFonts.push("Sora, sans-serif");
  }
  if (!DefaultFonts.includes("DM Sans, sans-serif")) {
    DefaultFonts.push("DM Sans, sans-serif");
  }
}
